import { render, staticRenderFns } from "./listaFilial.vue?vue&type=template&id=620e9e7b&scoped=true&"
import script from "./listaFilial.vue?vue&type=script&lang=js&"
export * from "./listaFilial.vue?vue&type=script&lang=js&"
import style0 from "./listaFilial.vue?vue&type=style&index=0&id=620e9e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e9e7b",
  null
  
)

export default component.exports